import React, { useMemo, useState, useRef } from 'react'
import { useEffect } from 'react';
import TableContainer from '../../components/Common/TableContainer';
// import { API_URL } from 'helpers/url_helper';
import axios from 'axios'
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Button,
  FormGroup,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { RoleCode, RoleName } from "./rolelistCol";
import { Link, useHistory,useLocation } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
// import getModuleAccess from 'components/Common/getAccessRights';
// import moduleList from 'common/data/moduleList';
// import { decryptData, encryptData } from 'helpers/crypto_helper';

// import {RoleList} from "common/data/constants"
import { decryptData } from "helpers/crypto_helper";
import { createRoles, fetchRoles } from 'store/actions';
import { useAuthUserDetails } from 'components/Common/getAuthUserDetails';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'common/pageLoader';
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";

function Roles() {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const history = useHistory()
  const [Id, setId] = useState("");
  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [userDetails, setUserDetails] = useState('');
  const [roleCode, setRoleCode] = useState('');
  // const [accessRight, setAccessRight] = useState([]);

  const [roleId, setRoleId] = useState(null);
  const [authDetails, setAuthDetails] = useState(null);
  const [isEdit, setIsEdit] = useState(false);

  const dispatch = useDispatch();

  const { roles, loading, error, success } = useSelector((state) => state.rolesReducer || {});

    useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    console.log("Final Employee Object:", authUserDetails);
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchRoles(unitId));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchRoles(authDetails?.unit_id));
      validation.resetForm();
      setIsEdit(false);
      setRoleId(null);
    }
  }, [authDetails, success, dispatch]);

  const validation = useFormik({

    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      role_name: "",
      is_act_as_admin: false,
    },

    validationSchema: Yup.object({
      role_name: Yup.string()
        .required("Role Name is required")
        .max(50, "Role Name must not exceed 50 characters")
        .matches(
          /^[a-zA-Z0-9 ]+$/,
          "Role Name allows only alphabets, numbers and spaces"
        ),
    }),

    onSubmit: async (values) => {

      const formData = new FormData();
      formData.append("unit_id", authDetails.unit_id);
      formData.append("role_name", values.role_name);
      formData.append("act_admin", values.is_act_as_admin ? "1" : "0");
      formData.append("created_by", authDetails.user_id);

      if (isEdit) {
        formData.append("role_id", roleId) // Include the stored holiday ID); // Existing holiday ID
      } else {
        formData.append("role_id", 0); // New holiday
      }

      dispatch(createRoles(formData));
    }
  })

  //table headers
  // const columns = useMemo(
  //   () => [
  //     {
  //       Header: "Action",
  //       className: "action-col",
  //       applyHeaderClass: true,
  //       Cell: cellProps => {
  //         return (
  //           <div className="d-flex gap-3">
  //             {/* {accessRight.edit_access === 1 && */}
  //             <Link
  //               to="#"
  //               className="text-success"
  //               onClick={() => {
  //                 const userData = cellProps.row.original;
  //                 handleUserClick(userData);
  //               }}
  //             >
  //               <i className="bx bxs-edit font-size-18" id="edittooltip" />
  //               <UncontrolledTooltip placement="top" target="edittooltip">
  //                 Edit
  //               </UncontrolledTooltip>
  //             </Link>
  //             {/* }

  //             {accessRight.delete_access === 1 && */}
  //             {/* <Link
  //               to="#"
  //               className="text-danger"
  //               onClick={() => {
  //                 const userData = cellProps.row.original;
  //                 onClickDelete(userData);
  //               }}
  //             >
  //               <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
  //               <UncontrolledTooltip placement="top" target="deletetooltip">
  //                 Delete
  //               </UncontrolledTooltip>
  //             </Link> */}
  //             {/* } */}
  //           </div>
  //         );
  //       },
  //     },
  //     {
  //       Header: "S.No",
  //       Cell: ({ row }) => roles.length - row.index,
  //       className: "serial-no",
  //       applyHeaderClass: true,
  //     },

  //     // {
  //     //   Header: 'Role Code',
  //     //   accessor: 'role_code',
  //     //   filterable: true,
  //     //   Cell: cellProps => {
  //     //     return <RoleCode {...cellProps} />;
  //     //   },
  //     // },
  //     {
  //       Header: 'Role Name',
  //       accessor: 'role_name',
  //       filterable: true,
  //       Cell: cellProps => {
  //         return <RoleName  {...cellProps} />;
  //       },
  //     },
  //     {
  //       Header: 'Act as Admin',
  //       accessor: row => (row.act_admin ? 'Yes' : 'No'),
  //       // Cell: ({ value }) => (value ? 'Yes' : 'No'),
  //     },
  //     {
  //       Header: 'Created By',
  //       accessor: 'created_by',
  //     },
  //     {
  //       Header: 'Created On',
  //       accessor: 'created_date',
  //     },
      
  //   ],
  //   // [accessRight.edit_access]
  //   [roles]
  // );

  const columns = useMemo(() => {
  const baseColumns = [
    {
      Header: "S.No",
      Cell: ({ row }) => roles.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    {
      Header: "Role Name",
      accessor: "role_name",
      filterable: true,
      Cell: cellProps => <RoleName {...cellProps} />,
    },
    {
      Header: "Act as Admin",
      accessor: row => (row.act_admin ? "Yes" : "No"),
    },
    {
      Header: "Created By",
      accessor: "created_by",
    },
    {
      Header: "Created On",
      accessor: "created_date",
    },
  ];

  // Action column addition based on permission
  if (canEdit ) {
    baseColumns.unshift({
      Header: "Action",
      className: "serial-no",
      applyHeaderClass: true,
      Cell: cellProps => (
        <div className="d-flex gap-3">
          {canEdit && (
            <Link
              to="#"
              className="text-success"
              onClick={() => {
                const userData = cellProps.row.original;
                handleUserClick(userData);
              }}
            >
              <i className="bx bxs-edit font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>
          )}
        </div>
      ),
    });
  }

  return baseColumns;
}, [roles, canEdit, canCreate]);

  useEffect(() => {
    // getRoles()
    setIsEdit(false);
    // const userDet = JSON.parse(localStorage.getItem("authUser"))
    if (localStorage.getItem("authUser")) {
      const obj = JSON.stringify(localStorage.getItem("authUser"))
      const data = JSON.parse(obj)
      const DecryptData = decryptData(data)
      const userDet = JSON.parse(DecryptData)
      setUserDetails(userDet.apimarket_user_code)
    }
  }, []);

  const toggle = () => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  };

  const handleUserClick = arg => {
    const user = arg;
    setId(user.role_id)
    setRoleId(user.role_id)
    setRoleCode(user.role_code)
    setIsEdit(true);
    setModal(true)

    validation.setValues({
      role_name: user.role_name,
      is_act_as_admin: Boolean(user.act_admin),
    });
  };
  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  // const onClickDelete = users => {
  //   setId(users._id)
  //   setDeleteModal(true);
  // };

  const handleDeleteUser = () => {
    // axios.delete(API_URL + "api/deleteRole", {
    //   headers: { "Content-type": "application/json" },
    //   data: { "id": Id }
    // })
    // swal("Deleted Successfully....!", {
    //   icon: "success",
    // });
    getRoles()

    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  // const getModuleAccessRight = () => {
  //   const accessData = getModuleAccess(moduleList.manageRoles)
  //   setAccessRight(accessData.data)
  //   if (accessData && (accessData.data.read_access == 0 &&  accessData.data.create_access == 0 && accessData.data.edit_access == 0 && accessData.data.delete_access == 0)) {
  //     history.push('/unAuthorized')
  //   }

  // }

  // useEffect(() => {
  //   getModuleAccessRight()
  // }, [])

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Loader loading={loading}/>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Configuration" breadcrumbItem="Roles" />
          <Row>
            <Col lg="12">
            {(canEdit || canCreate) && (
<Card>
              <CardBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row form>
                      <Col xs={4}>
                        <FormGroup className="mb-3">
                          <Label for="role_name" className="form-label">
                            Role Name <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="role_name"
                            name="role_name"
                            type="text"
                            maxLength={50}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.role_name || ""}
                            invalid={!!(validation.touched.role_name && validation.errors.role_name)}
                          />
                          {validation.touched.role_name && validation.errors.role_name && (
                            <div className="text-danger">{validation.errors.role_name}</div>
                          )}
                        </FormGroup>
                      </Col>

                      <Col md={4} className="mb-0 d-flex align-items-center">
                        <FormGroup check className="d-flex align-items-center mb-0">
                          <Input
                            type="checkbox"
                            id="is_act_as_admin"
                            name="is_act_as_admin"
                            className="me-2"
                            onChange={validation.handleChange}
                            checked={validation.values.is_act_as_admin}
                          />
                          <Label for="is_act_as_admin" className="mb-0">
                            Is Act As Admin
                          </Label>
                        </FormGroup>
                      </Col>

                      <Col md="4" className="d-flex align-items-center justify-content-end mt-4">
                        <Button type="submit" className="btn button-save me-2">
                          <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                        </Button>
                        <Button
                          color="secondary"
                          type="button"
                          onClick={() => {
                            validation.resetForm();
                            setIsEdit(false);
                            setRoleId(null);
                          }}
                          className="btn button-cancel"
                        >
                          <i className="fas fa-sync me-1" /> Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
              </CardBody>
            </Card>
            )}
            
              <Card>
                <CardBody>

                  <TableContainer
                    columns={columns}
                    data={roles && roles.length > 0 ? roles : []}
                    isGlobalFilter={true}
                    // isAddRole={accessRight && accessRight.create_access === 1 ? true : false}
                    // isAddRole={true}
                    handleUserClick={handleUserClicks}
                    customPageSize={10}
                  // className="custom-header-css"
                  />

                  {/* <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Edit Role" : "Add Role"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row form>
                          <Col xs={4}>
                            <div className="mb-3">
                              <Label className="form-label">Role Name <span className="text-danger">*</span></Label>
                              <Input
                                name="role_name"
                                label="Role Name"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.role_name || ""}
                                invalid={
                                  validation.touched.role_name &&
                                    validation.errors.role_name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.role_name &&
                                validation.errors.role_name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.role_name}
                                </FormFeedback>
                              ) : null}
                            </div>

                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Save
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}


export default Roles;